import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import loginPool from '../../aws-pool/login-pool';
import { authContext } from '../../data/authContext';
import { getGuestDonorCredentials } from '../../common';
import { config } from '../../common/constant';

let authPromise = null;



export function isDonorUserLoggedIn() {
    return Boolean(authContext.userToken);
}

function storeTokens(idToken, refreshToken) {
    authContext.guestDonorIdToken = idToken;
    authContext.guestDonorRefreshToken = refreshToken || '';
    return idToken;
}


async function authenticateViaCognitoSdk(username, password) {
    return new Promise((resolve, reject) => {
        const user = new CognitoUser({ Username: username, Pool: loginPool });
        const authDetails = new AuthenticationDetails({
            Username: username,
            Password: password,
        });

        user.authenticateUser(authDetails, {
            onSuccess: (data) => {
                storeTokens(data.idToken.jwtToken, data.refreshToken.token);
                user.signOut();
                resolve(authContext.guestDonorIdToken);
            },
            onFailure: reject,
            newPasswordRequired: () => reject(new Error('Guest donor password change required')),
        });
    });
}

export function authenticateGuestDonor() {

    if (authContext.guestDonorIdToken) {
        return Promise.resolve(authContext.guestDonorIdToken);
    }

    if (authPromise) {
        return authPromise;
    }

    authPromise = getGuestDonorCredentials()
        .then(({ username, password }) => {
            const currentUser = loginPool.getCurrentUser();
            if (currentUser && currentUser.getUsername() !== username) {
                return null;
            }
            return authenticateViaCognitoSdk(username, password);
        })
        .then((token) => {
            authPromise = null;
            return token;
        })
        .catch((error) => {
            authPromise = null;
            throw error;
        });

    return authPromise;
}
